module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/exclamation-triangle-0a032c3a61333bb5030b513f0b0de8d7.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/exclamation-triangle.svg
// module id = STiM
// module chunks = 24